import React, { FormEvent, useState } from 'react'
import {
  Typography,
  TextField,
  Button,
  CircularProgress,
  useTheme,
} from '@mui/material'
import { appleSignIn, googleSignIn } from '../utils/firebase';
import SocialButtons from '../components/SocialButtons';

type Props = {
  onSingin: (email: string, passowrd: string) => void;
  inProgress: boolean;
}

const ProfileSignin = (props: Props) => {
  const { onSingin, inProgress } = props
  const theme = useTheme();

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()

    onSingin(email, password)
  }

  return (
    <>
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          color: theme.palette.grey[800],
          fontWeight: 500,
          mb: 3
        }}
      >
        Welcome Back
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          margin="normal"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          type="email"
          sx={{
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: theme.palette.primary.main,
              },
            },
          }}
        />
        <TextField
          fullWidth
          label="Password"
          variant="outlined"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          type="password"
          sx={{
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: theme.palette.primary.main,
              },
            },
          }}
        />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          disabled={inProgress}
          sx={{
            mt: 3,
            mb: 2,
            height: 48,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          {inProgress ? (
            <CircularProgress size={24} />
          ) : (
            'Sign In'
          )}
        </Button>
      </form>

      <SocialButtons
        onGooglePress={() => googleSignIn()}
        onApplePress={() => appleSignIn()}
      />

    </>
  )
}

export default ProfileSignin